import React from 'react';
import FooterWrapper from '../components/FooterWrapper';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-black-pure flex flex-col overflow-hidden">
      
      <section className="relative z-10 bg-black-pure pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-geist text-white text-[24px] font-normal mb-8">IMPRESSUM</h1>
          
          <div className="space-y-12 font-geist">
            <div>
              <h2 className="text-white text-lg font-normal mb-3">Angaben gemäß § 5 TMG</h2>
              <p className="text-[#787c87] text-sm font-normal">BLCKs e.U.</p>
              <p className="text-[#787c87] text-sm font-normal">Philipp Fuchs</p>
              <p className="text-[#787c87] text-sm font-normal">Heinrich-Casper-Gasse 29/9</p>
              <p className="text-[#787c87] text-sm font-normal">8010 Graz</p>
              <p className="text-[#787c87] text-sm font-normal">Österreich</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">KONTAKT</h2>
              <p className="text-[#787c87] text-sm font-normal">E-Mail: hello@blcks.at</p>
              <p className="text-[#787c87] text-sm font-normal">Internet: www.blcks.at</p>
            </div>

            <div>
              <p className="text-[#787c87] text-sm font-normal">Firmenbuchnummer: FN 642541 p</p>
              <p className="text-[#787c87] text-sm font-normal">Firmenbuchgericht: Landesgericht für Zivilrechtssachen Graz</p>
              <p className="text-[#787c87] text-sm font-normal">Firmensitz: Graz</p>
              <p className="text-[#787c87] text-sm font-normal">Unternehmensgegenstand: IT-Dienstleistungen</p>
              <p className="text-[#787c87] text-sm font-normal">UID-Nummer: ATU12345678</p>
              <p className="text-[#787c87] text-sm font-normal">GISA (Gewerbeinformationssystem Austria): 37859183</p>
              <p className="text-[#787c87] text-sm font-normal">Berufsrecht: Muster Berufsrechtliche Regelung z.B: www.ris.bka.gv.at</p>
              <p className="text-[#787c87] text-sm font-normal">Berufsbezeichnung: Webdesigner & Developer</p>
              <p className="text-[#787c87] text-sm font-normal">Verleihungsstaat: Österreich</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">Grundlegende inhaltliche Ausrichtung</h2>
              <p className="text-[#787c87] text-sm font-normal">Informationen über die von BLCKs e.U. angebotenen Produkte und Leistungen.</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">Datenschutz Verantwortlicher</h2>
              <p className="text-[#787c87] text-sm font-normal">Philipp Fuchs</p>
              <p className="text-[#787c87] text-sm font-normal">Heinrich-Casper-Gasse 29/9</p>
              <p className="text-[#787c87] text-sm font-normal">8010 Graz</p>
              <p className="text-[#787c87] text-sm font-normal">Österreich</p>
              <p className="text-[#787c87] text-sm font-normal">E-Mail: hello@blcks.at</p>
              <p className="text-[#787c87] text-sm font-normal">Impressum: https://www.blcks.at/impressum</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">Rechtliche Hinweise</h2>
              <p className="text-[#787c87] text-sm font-normal">Sämtliche Texte, Grafiken usw. auf dieser Website wurden sorgfältig geprüft. Dennoch kann keine Garantie für Richtigkeit, Vollständigkeit und Aktualität der Angaben übernommen werden.</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">Urheberrecht</h2>
              <p className="text-[#787c87] text-sm font-normal">Sämtliche Texte, Grafiken und Bilder sind urheberrechtlich geschützt. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der ausdrücklichen schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">Links</h2>
              <p className="text-[#787c87] text-sm font-normal mb-4">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich, wobei die Seiten zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft wurden und rechtswidrige Inhalte nicht erkennbar waren. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Gesetzesverstößen werden die betreffenden Links umgehend entfernt.</p>
              
              <p className="text-[#787c87] text-sm font-normal mb-4">Im Einklang mit dem E-Commerce-Gesetz machen wir darauf aufmerksam, dass an uns gesendete E-Mails nur werktags abgerufen werden.</p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">EU-Streitschlichtung</h2>
              <p className="text-[#787c87] text-sm font-normal">Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.</p>
              <p className="text-[#787c87] text-sm font-normal mt-4">Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE" className="text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a> zu richten. Die dafür notwendigen Kontaktdaten finden Sie oben in unserem Impressum.</p>
              <p className="text-[#787c87] text-sm font-normal mt-4">Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default Impressum;